<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr-other" style="padding-right: 5px"></i>
        单位信息
      </div>
    </div>
    <ul class="tab-wrap">
      <li
        :class="`tab-btn ${nowIndex == index && 'active'}`"
        @click="changeTab(index)"
        v-for="(tab, index) in tabList"
      >
        {{ tab.title }}
      </li>
    </ul>
    <el-form
      ref="form"
      :model="form"
      label-width="110px"
      :rules="rules"
      class="mt20"
      v-show="nowIndex == 0"
    >
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item
            label="单位编号"
            :rules="{
              message: '请填写/选择',
              trigger: 'change',
              required: true,
            }"
            prop="base.c_number"
          >
            <el-input v-model="form.base.c_number"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            label="单位类型"
            :rules="{
              message: '请填写/选择',
              trigger: 'change',
              required: true,
            }"
            prop="base.c_type"
          >
            <v-select :value.sync="form.base.c_type" :id="1"></v-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            label-width="200px"
            label="上级单位/文物所属监督机构"
            prop="base.c_superior"
          >
            <el-select v-model="form.base.c_superior">
              <el-option
                v-for="item in shangjioption"
                :key="item.value"
                :label="item.key"
                :value="item.value"
              ></el-option>
              <!-- <el-option :value="0" label="请选择上级单位"></el-option>
                            <el-option :value="2" label="联网单位"></el-option>
                            <el-option :value="3" label="消防监管单位"></el-option>
                            <el-option :value="4" label="维保单位"></el-option>
                            <el-option :value="5" label="其他"></el-option> -->
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            label="单位名称"
            :rules="{
              message: '请填写/选择',
              trigger: 'change',
              required: true,
            }"
            prop="base.c_name"
          >
            <el-input v-model="form.base.c_name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="营业执照号码" prop="base.c_imployee_number ">
            <el-input v-model="form.base.c_imployee_number"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="入网日期" prop="base.c_in_net">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="form.base.c_in_net"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="BIM" prop="base.isbim">
            <el-radio-group v-model="form.base.isbim">
              <el-radio :label="1">有</el-radio>
              <el-radio :label="0">无</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="联网状态" prop="base.c_net_status">
            <el-radio-group v-model="form.base.c_net_status">
              <el-radio :label="1">已联网</el-radio>
              <el-radio :label="0">未联网</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="安装信息表" prop="base.c_setup_table">
            <el-radio-group v-model="form.base.c_setup_table">
              <el-radio :label="1">有</el-radio>
              <el-radio :label="0">无</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <!--                <el-col :span="6">-->
        <!--                    <el-form-item label="省" :rules="{message:'请填写/选择',trigger:'change',required:true}" prop="base.c_province">-->
        <!--                        <el-select v-model="form.base.c_province" placeholder="请选择省份" @change="proChanege">-->
        <!--                            <el-option :value="item.area_code+''" :label="item.area_name"-->
        <!--                                       v-for="item in allAreaList"></el-option>-->
        <!--                        </el-select>-->
        <!--                    </el-form-item>-->
        <!--                </el-col>-->
        <!--                <el-col :span="6">-->
        <!--                    <el-form-item label="市" :rules="{message:'请填写/选择',trigger:'change',required:true}" prop="base.c_city">-->
        <!--                        <el-select v-model="form.base.c_city" placeholder="请选择市" @change="cityChanege">-->
        <!--                            <el-option :value="item.area_code+''" :label="item.area_name"-->
        <!--                                       v-for="item in cityList"></el-option>-->
        <!--                        </el-select>-->
        <!--                    </el-form-item>-->
        <!--                </el-col>-->
        <!--                <el-col :span="6">-->
        <!--                    <el-form-item label="区" :rules="{message:'请填写/选择',trigger:'change',required:true}" prop="base.c_area">-->
        <!--                        <el-select v-model="form.base.c_area" placeholder="请选择区">-->
        <!--                            <el-option :value="item.area_code+''" :label="item.area_name"-->
        <!--                                       v-for="item in areaList"></el-option>-->
        <!--                        </el-select>-->
        <!--                    </el-form-item>-->
        <!--                </el-col>-->

        <el-col :span="6">
          <el-form-item
            label="地区"
            prop="base.c_area"
            :rules="{ message: '请填写/选择', trigger: 'blur', required: true }"
          >
            <el-cascader
              :options="area"
              v-model="areaValue"
              @change="areaChange"
              :props="{
                value: 'area_code',
                label: 'area_name',
                children: 'childArea',
              }"
            >
              <template slot-scope="{ node, data }">
                <span>{{ data.area_name }}</span>
              </template>
            </el-cascader>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="详细地址" prop="base.c_address">
            <el-input v-model="form.base.c_address"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="级别" prop="base.c_level">
            <!-- <v-select :value.sync="form.base.c_level" :id="6"></v-select> -->
            <el-input v-model="form.base.c_level"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="安全监管级别" prop="base.c_safe_level">
            <v-select :value.sync="form.base.c_safe_level" :id="38"></v-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            label="所属行业"
            prop="base.c_belong_profession"
            :rules="{ message: '请填写/选择', trigger: 'blur', required: true }"
          >
            <v-select
              :value.sync="form.base.c_belong_profession"
              :id="66"
            ></v-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="类型" prop="base.c_profession_type">
            <!-- <v-select :value.sync="form.base.c_profession_type" :id="84"></v-select> -->
            <el-input v-model="form.base.c_profession_type"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="邮箱" prop="base.c_orgin_num">
            <el-input v-model="form.base.c_orgin_num"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item
            label-width="140px"
            label="消防安全重点单位"
            prop="base.c_import_company"
            :rules="{ message: '请填写/选择', trigger: 'blur', required: true }"
          >
            <el-radio-group v-model="form.base.c_import_company">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="责任人" prop="base.c_responsible">
            <el-input v-model="form.base.c_responsible"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="责任人联系方式" prop="base.c_phone">
            <el-input v-model="form.base.c_phone"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="管理人">
            <el-input v-model="form.base.c_manager"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="管理人联系方式">
            <el-input v-model="form.base.c_manager_phone"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="部门负责人" prop="base.c_department_responsible">
            <el-input v-model="form.base.c_department_responsible"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="建筑产权单位" prop="base.c_power_company ">
            <el-input v-model="form.base.c_power_company"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="职工数" prop="base.c_woker">
            <el-input v-model="form.base.c_woker"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="占地面积" prop="base.c_land_area">
            <el-input v-model="form.base.c_land_area"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="总面积" prop="base.c_total_area">
            <el-input v-model="form.base.c_total_area"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            label="东经"
            prop="base.lon"
            :rules="{ message: '请填写/选择', trigger: 'blur', required: true }"
          >
            <el-input v-model="form.base.lon" placeholder="请输入"></el-input>
            <getLoation @callback="getLoa"></getLoation>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            label="北纬"
            prop="base.lat"
            :rules="{ message: '请填写/选择', trigger: 'blur', required: true }"
          >
            <el-input v-model="form.base.lat" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="消防信息" prop="base.c_firefighting_messsage">
            <el-input v-model="form.base.c_firefighting_messsage"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="单位简介" prop="base.c_bim_href">
            <el-input
              type="textarea"
              :rows="5"
              v-model="form.base.c_bim_href"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="视频相关字段" prop="base.c_video_filter">
            <el-input v-model="form.base.c_video_filter"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="视频IP/域名" prop="base.c_video_ip">
            <el-input v-model="form.base.c_video_ip"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="端口/空" prop="base.c_port">
            <el-input v-model="form.base.c_port"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="插件类型" prop="base.c_plugin_type">
            <v-select :value.sync="form.base.c_plugin_type" :id="86"></v-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div
      v-for="(item, index1) in tabList"
      v-show="nowIndex == index1"
      v-if="index1 !== 0"
    >
      <div class="btn-box">
        <el-button
          type="info"
          size="small"
          v-show="nowIndex == index1 && $route.query.id"
          v-if="index1 == 10"
          plain
          @click="downmuban()"
          >下载模板</el-button
        >

        <el-upload
          class="ml10"
          :action="$config.apiUrl + '/trxf/main/xf/danwei/dianwei/dianweiexcel'"
          :headers="{ token: $store.state.token }"
          v-show="nowIndex == index1 && $route.query.id"
          v-if="index1 == 10"
          :show-file-list="false"
          :on-success="handlesuccess"
        >
          <el-button
            size="small"
            type="success"
            v-show="nowIndex == index1 && $route.query.id"
            v-if="index1 == 10"
            >导入文件</el-button
          >
        </el-upload>
        <el-button
          class="ml10"
          size="small"
          @click="output()"
          v-show="nowIndex == index1 && $route.query.id"
          v-if="index1 == 10"
          type="primary"
          plain
        >
          导出文件
        </el-button>

        <el-button
          class="btn ml10"
          size="small"
          icon="icon-tr-newly-added"
          type="primary"
          @click="addList(index1)"
        >
          新增
        </el-button>
      </div>

      <table class="common-table mt20">
        <thead>
          <tr>
            <th v-for="data in item.data">
              {{ data.text }}
            </th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(data, index) in form[tabList[index1].form]">
            <td
              class="common-add"
              v-for="(input, key, index2) in tabList[index1].data"
            >
              <el-input
                placeholder="请输入"
                v-model="form[tabList[index1].form][index][input.form_name]"
                v-if="input.type == 'text'"
              ></el-input>
              <div v-if="input.type == 'select'">
                <v-select
                  :value.sync="
                    form[tabList[index1].form][index][input.form_name]
                  "
                  :id="input.op_id || input.option"
                ></v-select>
              </div>
              <el-date-picker
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                v-model="form[tabList[index1].form][index][input.form_name]"
                v-if="input.type == 'date'"
              ></el-date-picker>
            </td>
            <td class="td-btn">
              <a class="clear-data" @click="del(index)">
                <i class="icon-tr-delete"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="btn-box">
      <div class="l-btn" @click="onSubmit">保存</div>
      <div class="l-btn ml20" @click="$router.back()">返回</div>
    </div>
  </div>
</template>

<script>
import { addCompany, editCompany } from "../../api/company";
import { getArea } from "../../api/common";
import { sigtype, port } from "./options";
import getLoation from "./getLoation";
export default {
  data() {
    return {
      area: [],
      areaValue: ["370000", "370200", "370202"],
      shangjioption: [],
      form: {
        base: {
          c_number: "",
          c_type: "",
          c_superior: "",
          c_name: "",
          c_phone: "",
          c_manager_phone: "",
          c_power_company: "",
          c_in_net: "",
          c_net_status: "",
          c_province: "370000",
          c_city: "370200",
          c_area: "370202",
          c_address: "",
          c_setup_table: "",
          isbim: "",
          c_level: "",
          c_safe_level: "",
          c_belong_profession: "",
          c_profession_type: "",
          c_orgin_num: "",
          c_responsible: "",
          c_manager: "",
          c_imployee_number: "",
          c_department_responsible: "",
          c_woker: "",
          c_land_area: "",
          c_total_area: "",
          c_firefighting_messsage: "",
          c_bim_href: "",
          c_video_filter: "",
          c_video_ip: "",
          c_port: "",
          c_plugin_type: "",
          lat: "",
          lon: "",
        },
        get_build: [],
        get_control: [],
        get_server: [],
        get_facility: [],
        get_transmission: [],
        get_interface: [],
        get_message: [],
        get_onduty: [],
        get_video: [],
        get_dianwei: [],
      },
      rules: {},
      nowIndex: 0,
      allAreaList: [],
      cityList: [],
      areaList: [],
      tabList: [
        { title: "基本信息", form: "base" },
        {
          title: "建筑信息",
          form: "get_build",
          data: [
            { form_name: "cb_use_type", type: "text", text: "建筑使用性质" },
            { form_name: "cb_height", type: "text", text: "高度" },
            { form_name: "cb_on", type: "text", text: "地上层数" },
            { form_name: "cb_under", type: "text", text: "地下层数" },
            { form_name: "cb_area", type: "text", text: "面积" },
            { form_name: "cb_name", type: "text", text: "建筑名称" },
            // {form_name: 'cb_yinqing', type: 'text', text: '火灾引擎'},
          ],
        },
        {
          title: "消防设施",
          form: "get_facility",
          data: [
            { form_name: "cf_name", type: "text", text: "消防设施名称" },
            { form_name: "cf_brand", type: "text", text: "消防品牌" },
            { form_name: "cf_norm", type: "text", text: "规格型号" },
            { form_name: "cf_node", type: "text", text: "节点数" },
            { form_name: "cf_quantity", type: "text", text: "数量" },
          ],
        },
        {
          title: "传输装备",
          form: "get_transmission",
          data: [
            {
              form_name: "ct_transmission_num",
              type: "text",
              text: "设备编号",
            },
            {
              form_name: "ct_transmission_type",
              type: "select",
              text: "设备类型",
              op_id: 28,
            },
            {
              form_name: "ct_transmission_model",
              type: "text",
              text: "设备型号",
            },
            { form_name: "ct_child_number", type: "text", text: "子号" },
            { form_name: "ct_part_num", type: "text", text: "部位号" },
            {
              form_name: "ct_transmission_name",
              type: "text",
              text: "设备名称",
            },
            { form_name: "ct_heart_beat", type: "text", text: "心跳时间(s)" },
            { form_name: "ct_local", type: "text", text: "安装位置" },
            { form_name: "ct_setup_data", type: "date", text: "安装日期" },
            { form_name: "ct_open_date", type: "date", text: "开通日期" },
          ],
        },
        {
          title: "接口资料",
          form: "get_interface",
          data: [
            { form_name: "ci_num", type: "text", text: "设备编号" },
            { form_name: "ci_snum", type: "text", text: "子号" },
            {
              form_name: "ci_message_type",
              type: "select",
              text: "信号类型",
              op_id: 171,
            },
            {
              form_name: "ci_sys_type",
              type: "select",
              text: "系统类型",
              op_id: 16,
            },
            {
              form_name: "ci_port",
              type: "select",
              text: "端口号",
              option: port,
            },
            { form_name: "ci_device_name", type: "text", text: "信号名称" },
            {
              form_name: "ci_info_type",
              type: "select",
              text: "信号分类",
              option: sigtype,
            },
            { form_name: "ci_simulation_sys", type: "text", text: "模拟系数" },
            { form_name: "ci_cap", type: "text", text: "上限" },
            { form_name: "ci_lower", type: "text", text: "下限" },
            { form_name: "ci_unit", type: "text", text: "单位" },
          ],
        },
        {
          title: "消防服务",
          form: "get_server",
          data: [
            { form_name: "cd_unit_name", type: "text", text: "单位名称" },
            {
              form_name: "cd_type",
              type: "select",
              text: "单位类型",
              op_id: 1,
            },
            { form_name: "cd_user", type: "text", text: "联系人" },
            { form_name: "cd_phone", type: "text", text: "联系人电话" },
          ],
        },
        // {
        //   title: "消控室",
        //   form: "get_control",
        //   data: [
        //     { form_name: "cc_num", type: "text", text: "消控室编号" },
        //     { form_name: "cc_name", type: "text", text: "消控室名称" },
        //     { form_name: "cc_build", type: "text", text: "所属建筑" },
        //     { form_name: "cc_address", type: "text", text: "地址" },
        //     { form_name: "cc_user", type: "text", text: "责任人" },
        //     { form_name: "cc_device", type: "text", text: "设备" },
        //   ],
        // },
        {
          title: "值班人员",
          form: "get_onduty",
          data: [
            { form_name: "co_name", type: "text", text: "值班人员" },
            { form_name: "co_phone", type: "text", text: "值班人电话" },
            { form_name: "co_duty", type: "text", text: "值班人职务" },
          ],
        },
        {
          title: "短信通知",
          form: "get_message",
          data: [
            { form_name: "cm_name", type: "text", text: "姓名" },
            // {form_name: 'cm_post', type: 'text', text: '岗位'},
            { form_name: "cm_phone", type: "text", text: "电话" },
            {
              form_name: "cm_push",
              type: "select",
              text: "是否推送",
              option: [
                { mc_id: 1, mc_name: "是" },
                { mc_id: 0, mc_name: "否" },
              ],
            },
            {
              form_name: "cm_push_type",
              type: "select",
              text: "推送类型",
              option: [
                { mc_id: "火警", mc_name: "火警" },
                { mc_id: "水位超限", mc_name: "水位超限" },
                { mc_id: "水压超限", mc_name: "水压超限" },
                { mc_id: "漏电流超限", mc_name: "漏电流超限" },
                { mc_id: "温度超限", mc_name: "温度超限" },
              ],
            },
          ],
        },
        {
          title: "视频监控",
          form: "get_video",
          data: [
            { form_name: "v_video_number", type: "text", text: "视频编号" },
            { form_name: "v_video_address", type: "text", text: "位置信息" },
          ],
        },
        {
          title: "点位管理",
          form: "get_dianwei",
          data: [
            { form_name: "cz_dw_write", type: "text", text: "点位信息" },
            { form_name: "cz_dw_miaoshu", type: "text", text: "位置描述" },
          ],
        },
      ],
    };
  },
  created() {
    this.$get("/trxf/main/sys/area/arealist").then((res) => {
      this.area = res.data;
      this.area.forEach((a) => {
        a.childArea.forEach((b) => {
          //log(b.childArea)
          b.childArea.forEach((c) => {
            if (!c.childArea.length) {
              c.childArea = null;
            }
          });
        });
      });
    });
    this.$post("/trxf/main/xf/danwei/xfdanweixinxi/querybasemap").then(
      (res) => {
        var arr = [];
        res.data.map((item, index) => {
          arr.push({ key: item.c_name, value: item.c_company_num });
        });
        arr.unshift({ key: "无", value: "" });
        this.shangjioption = arr;
      }
    );
    if (this.$route.query.id) {
      this.getList();
    }
  },
  mounted() {},
  components: {
    getLoation,
  },
  methods: {
    //导出
    getList() {
      this.$get(
        "/trxf/main/xf/danwei/xfdanweixinxi/detailbase/" + this.$route.query.id
      ).then((res) => {
        var {
          from: { get_build },
          from,
        } = res;
        if (get_build.length) {
          get_build.map((item, index) => {
            item.old_name = item.cb_name;
          });
        }
        this.form = res.from;
        this.$set(this, "areaValue", [
          res.from.base.c_province,
          res.from.base.c_city,
          res.from.base.c_area,
        ]);
        //this.areaValue = [res.from.base.c_province,res.from.base.c_city,res.from.base.c_area]
      });
    },
    output() {
      var url = `${this.$config.apiUrl}/trxf/main/xf/danwei/dianwei/dianweidownload?c_company_num=${this.form.base.c_company_num}`;
      window.open(url, "_blank");
    },
    areaChange(val) {
      log(val);
      this.form.base.c_province = val[0];
      this.form.base.c_city = val[1];
      this.form.base.c_area = val[2];
    },
    getLoa(val) {
      this.form.base.lon = String(val[0]);
      this.form.base.lat = String(val[1]);
    },
    proChanege(flag) {
      this.cityList = [];
      this.areaList = [];
      flag !== 1 && (this.form.base.c_city = "");
      flag !== 1 && (this.form.base.c_area = "");
      this.allAreaList.forEach((it) => {
        if (it.area_code == this.form.base.c_province) {
          this.cityList = it.city;
        }
      });
    },
    cityChanege(flag) {
      this.areaList = [];
      !flag && (this.form.base.c_area = "");
      this.cityList.forEach((it) => {
        if (it.area_code == this.form.base.c_city) {
          this.areaList = it.get_area;
        }
      });
    },
    addList(index) {
      let obj = {};
      this.tabList[this.nowIndex].data.forEach((it) => {
        obj[it.form_name] = "";
      });
      this.form[this.tabList[this.nowIndex].form].push(obj);
    },
    del(index) {
      this.form[this.tabList[this.nowIndex].form].splice(index, 1);
    },
    changeTab(index) {
      this.nowIndex = index;
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.save();
        } else {
          this.nowIndex = 0;
          return false;
        }
      });
    },
    // 模板下载

    downmuban() {
      var url = `${this.$config.apiUrl}trxf/main/xf/danwei/dianwei/downloadmoban?c_company_num=${this.form.base.c_company_num}`;
      window.open(url, "_blank");
    },
    //文件上传成功
    handlesuccess(res) {
      if (res.code == 500) {
        this.$message.error("导入失败，检查文件模板");
      } else {
        // this.$message.success("导入成功");
        this.$message({
                message: '导入成功',
                type: 'success',
                duration: 700,
              });
        this.getList();
      }
    },
    //上传失败

    // handleerror(res){
    //   // console.log(res.code)
    //   // if(res.code==500){
    //   //   console.log('aaa')
    //   //   this.$message.error("导入失败")
    //   // }
    // },

    save() {
      var int = [
        "c_type",
        "c_net_status",
        "c_setup_table",
        "c_import_company",
        "c_imployee_number ",
        "c_manager_phone  ",
        "c_level",
        "c_safe_level",
        "c_belong_profession",
        "c_profession_type",
        "c_woker",
        "c_land_area",
        "c_total_area",
        "c_port",
        "c_plugin_type",
        "cb_height",
        "cb_on",
        "cf_node",

        "cf_quantity",
        "ci_message_type",
        "ci_sys_type",
        "ci_port",

        "cm_push",
        "cd_type",
        "ct_transmission_type",
        "ct_child_number",
        "ct_part_num",
        "ct_heart_beat",
      ];

      for (var key in this.form) {
        int.forEach((it) => {
          if (this.form.base[it]) {
            this.form.base[it] = +this.form.base[it];
          }
          if (key != "base") {
            this.form[key].forEach((im) => {
              if (im[it]) {
                im[it] = +im[it];
              }
            });
          }
        });
      }
      // console.log(this.form.get_build)
      var build_list = this.form.get_build;
      for (var i = 0; i < build_list.length; i++) {
        var item = build_list[i].cb_name;
        for (var j = i + 1; j < build_list.length; j++) {
          if (item === build_list[j].cb_name) {
            this.$message.warning("建筑名称不可以相同");
            return false;
          }
        }
      }

      var get_transmission = this.form.get_transmission;
      if (get_transmission.length) {
        for (var i = 0; i < get_transmission.length; i++) {
          if (!get_transmission[i].ct_transmission_num) {
            this.$message.warning("传输设备编号不可为空");
            return false;
          }
        }
      }
      var get_interface = this.form.get_interface;

      if (get_interface.length) {
        for (var i = 0; i < get_interface.length; i++) {
          if (!get_interface[i].ci_num) {
            this.$message.warning("接口资料编号不可为空");

            return false;
          } else if (
            get_interface[i].ci_message_type == 172 &&
            !get_interface[i].ci_device_name
          ) {
            this.$message.warning("信号名称不可为空");
            return false;
          }
        }
      }
      // console.log('处理逻辑')
      let logading = this.$loading({ background: "rgba(0, 0, 0, 0.6)" });

      if (!this.$route.query.id) {
        addCompany(this.form)
          .then((res) => {
            if (res.code == 500) {
              this.$message.warning(res.msg);
              return false;
            }
            if (res.code < 1000) {
              // this.$message.success("保存成功");
              this.$message({
                message: '保存成功',
                type: 'success',
                duration: 700,
              });
              this.$router.back();
            }
            logading.close();
          })
          .catch((res) => {
            logading.close();
          });
      } else {
        editCompany(this.form)
          .then((res) => {
            if (res.code == 500) {
              this.$message.warning(res.msg);
              return false;
            }
            if (res.code < 1000) {
              // this.$message.success("保存成功");
              this.$message({
                message: '保存成功',
                type: 'success',
                duration: 700,
              });
              this.$router.back();
            }
            logading.close();
          })
          .catch((res) => {
            logading.close();
          });
      }
    },
  },
};
</script>

<style scoped></style>
